module.exports = __webpack_public_path__ + "media/images/third_party_logos/Billy_Casper_Signature-38f4d90dd179d03a7977ebf50b694e6e.png";